export const selectStyle = {
    
    control: (provided, state) => ({
        ...provided,
        border: state.isFocused ? '1px solid var(--border-color)' : '1px solid var(--border-color)',
        boxShadow: state.isFocused ? 'none' : 'none',
        '&:hover': {
            border: state.isFocused ? '1px solid var(--border-color)' : '1px solid var(--border-color)', 
        },
        minHeight: "35px",
        width: '100%',
        cursor: 'pointer',
        borderRadius: '5px',
    }),


    menuList: (provided, state) => ({
        ...provided,  
         '::-webkit-scrollbar': {
            height: '5px',  
            width: '5px',
            border: '1px solid transparent',
        }, 
        '::-webkit-scrollbar-track': {
            background: 'var(--secondary-background)' 
        }, 
        '::-webkit-scrollbar-thumb': {
            background:  '#909090',
            position: 'fixed',
            cursor: 'pointer',
            borderRadius: '3px', 
        }, 
    }),



    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),

    indicatorsContainer: (provided) => ({
        ...provided,
        //  display: 'none',  
        padding: '0px',
    }),

    dropdownIndicator: (provided) => ({
        ...provided,
        //display: 'none', 
        color: 'var(--placeholder-text-color)',
        fontWeight: '500',
        padding: '4px',
        "svg": {
            width: '14px',
            height: '14px',
        }
    }),

    clearIndicator: (provided) => ({
        ...provided,
        //display: 'none', 
        color: 'var(--placeholder-text-color)',
        fontWeight: '500',
        padding: '0px',
        "svg": {
            width: '14px',
            height: '14px',
        }
    }),

    option: (styles, { isDisabled, isFocused, isSelected }) => {
        let backgroundColor;
        let color;
        let cursor = isDisabled ? 'not-allowed' : 'pointer';

        if (isDisabled) {
            backgroundColor = undefined;
            color = 'var(--text-color)';
        } else if (isSelected) {
            backgroundColor = 'var(--secondary-background)';
            color = undefined;
        } else if (isFocused) {
            backgroundColor = 'var(--secondary-background)';
            color = "var(--text-color)";
        } else {
            backgroundColor = undefined;
            color = "var(--text-color)";
        }

        let activeBackgroundColor;
        if (!isDisabled) {
            if (isSelected) {
                activeBackgroundColor = '#fff';
            } else {
                activeBackgroundColor = '#fff';
            }
        }

        return {
            ...styles,
            fontSize: '13px',
            fontWeight: '500',
            color: "var(--text-color)",
            backgroundColor: backgroundColor,
            cursor: cursor,
            overflow: 'hidden',
            ':active': {
                ...styles[':active'],
                backgroundColor: backgroundColor,
            },
        };
    },

    placeholder: (provided, state) => ({
        ...provided,
        color: "var(--placeholder-text-color)",
        fontSize: "13px",
        fontWeight: '500',
    }),

    singleValue: (provided, state) => ({
        ...provided,
        color: "var(--text-color)",
        fontSize: "13px",
        fontWeight: '500',
    }),

    input: (provided, state) => ({
        ...provided,
        color: "var(--text-color)",
        fontSize: "13px",
        fontWeight: '500',
    }),
 
 
    menu: (provided, state) => ({
        ...provided,
        zIndex: "2",
    }),
  
 


};

 